/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CimdClientPreset,
  CimdClientPreset$inboundSchema,
} from "./cimdclientpreset.js";

/**
 * Result type for listing the CIMD preset catalog.
 */
export type ListCimdClientPresetsResult = {
  items: Array<CimdClientPreset>;
};

/** @internal */
export const ListCimdClientPresetsResult$inboundSchema: z.ZodMiniType<
  ListCimdClientPresetsResult,
  unknown
> = z.object({
  items: z.array(CimdClientPreset$inboundSchema),
});

export function listCimdClientPresetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListCimdClientPresetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListCimdClientPresetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCimdClientPresetsResult' from JSON`,
  );
}
